import { AccountingProvider } from '../graphql';
import { FeatureFlags } from '../third-parties';

export const ACCOUNTING_PROVIDER_NAMES: Record<AccountingProvider, string> = {
  QUICKBOOKS: 'QuickBooks',
  NETSUITE: 'NetSuite',
  SELF_REPORTED: 'Accounting CSV Upload',
};

export const ACCOUNTING_PROVIDER_FLAGS: Record<AccountingProvider, keyof FeatureFlags> = {
  QUICKBOOKS: 'enableQuickbooks',
  NETSUITE: 'enableNetsuite',
  SELF_REPORTED: 'enableAccountingCsvUpload',
};
